import useCertificateStampDocument from './useCertificateStampDocument'
import { Grid } from '@material-ui/core'
import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import useTranslate from '../../../../../i18n/useTranslate'
import React from 'react'
import UploadDoc from '../../../shareUI/uploadDoc/uploadDoc'

export type ResultOfConsiderViewType = ReturnType<typeof useCertificateStampDocument> & CertificateStampDocumentType

const CertificateStampDocView: React.FC<ResultOfConsiderViewType> = (props) => {
    const {
        hideCertificate,
        initialUploadFile,
        initialUploadFileCer,
        documentTopicList,
        cerTopicList,
        onClickFileStamp,
    } = props

    const translate = useTranslate()
    return (
        <Form
            onSubmit={() => {}}
            initialValues={{
                uploadFile: initialUploadFileCer,
                uploadFileCerDoc: initialUploadFile,
            }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(props) => {
                return (
                    <React.Fragment>
                        <Grid container spacing={2} justify={'flex-end'}>
                            <Grid item xs={12} md={12} lg={12}>
                                <UploadDoc
                                    name={'uploadFileCerDoc'}
                                    initialData={initialUploadFile}
                                    documentTitleList={documentTopicList}
                                    title={translate.get('LABEL.DOC_CERTIFIED')}
                                    isViewMode={true}
                                    disabledBtn={true}
                                    onClickOpenFile={onClickFileStamp}
                                />
                            </Grid>

                            {!hideCertificate && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <UploadDoc
                                        initialData={initialUploadFileCer}
                                        documentTitleList={cerTopicList}
                                        title={translate.get('LABEL.CERTIFICATE')}
                                        isViewMode={true}
                                        disabledBtn={true}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </React.Fragment>
                )
            }}
        </Form>
    )
}
//Controler
export type CertificateStampDocumentType = {
    callbackSaveComplete?: (resStatus: number, isDraft: boolean) => void
    isHideDocumentCertificate?: boolean
}
const CertificateStampDoc: React.FC<CertificateStampDocumentType> = (props) => {
    const useCertificateStampDocumentModel = useCertificateStampDocument(props)
    return <CertificateStampDocView {...useCertificateStampDocumentModel} {...props} />
}

export default CertificateStampDoc
